module.exports = __webpack_public_path__ + "img/simple-check.062ef570.gif";